/** Panel de filtros colapsado (1 = colapsado) — claves por módulo operativo. */
export const POS_FILTERS_COLLAPSED_STORAGE_KEY = '@vuelto_pos_filters_collapsed';
export const CATALOG_FILTERS_COLLAPSED_STORAGE_KEY = '@vuelto_catalog_filters_collapsed';
export const STOCK_FILTERS_COLLAPSED_STORAGE_KEY = '@vuelto_stock_filters_collapsed';
export const PROMOTIONS_FILTERS_COLLAPSED_STORAGE_KEY = '@vuelto_promotions_filters_collapsed';
export const EXPENSES_FILTERS_COLLAPSED_STORAGE_KEY = '@vuelto_expenses_filters_collapsed';
export const EXPENSE_PAYMENTS_FILTERS_COLLAPSED_STORAGE_KEY = '@vuelto_expense_payments_filters_collapsed';
export const SALES_FILTERS_COLLAPSED_STORAGE_KEY = '@vuelto_sales_filters_collapsed';
export const CUSTOMER_FILTERS_COLLAPSED_STORAGE_KEY = '@vuelto_fiado_filters_collapsed';
